import { Equipment } from '../types/project';

// The single gateway for equipment INSERT rows, sibling to toSupabasePayload()
// for projects. It exists because of a real staging failure (2026-09-01):
// supabase-js builds one shared column list from the UNION of keys across the
// inserted rows, and PostgREST then writes an explicit NULL — not the column
// DEFAULT — for any row missing one of those keys. A dwelling-inventory row
// (which carries load_role/value_source) mixed with a freshly added proposed
// row (which didn't) turned the batch insert into a NOT NULL violation on
// load_role. Every insert therefore goes through here, where both role fields
// are made explicit on every row.
export function toEquipmentInsertRows(
  equipment: Equipment[],
  projectId: string
): Array<Record<string, unknown>> {
  return equipment.map((eq) => ({
    ...eq,
    project_id: projectId,
    load_role: eq.load_role ?? 'proposed',
    value_source: eq.value_source ?? 'nameplate',
    on_laundry_circuit: eq.on_laundry_circuit ?? false,
    includes_backup_heat: eq.includes_backup_heat ?? null,
  }));
}
